import { Heading } from "@planningcenter/doxy-web"
import { PreferredEmailAddressSelector } from "./components/PreferredEmailAddressSelector"
import { SendsReceiptsSelector } from "./components/SendsReceiptsSelector"
import { css } from "@emotion/react"
import { useGivingPersonContext } from "../hooks/useGivingPersonContext"

export default function Notifications() {
  const { givingPerson } = useGivingPersonContext()

  return (
    <section>
      <div className="mb-2">
        <Heading level={1} size={2} text="Notifications" />
      </div>
      <div
        className="p-2"
        css={css`
          border: 1px solid var(--color-static-gray93);
          border-radius: 8px;
        `}
      >
        <div className="d-f fd-c g-3">
          {givingPerson.email_addresses.length > 1 && (
            <PreferredEmailAddressSelector
              preferredEmailAddress={
                givingPerson.giving_preferred_email_address
              }
              emailAddresses={givingPerson.email_addresses}
            />
          )}
          <SendsReceiptsSelector value={givingPerson.sends_receipts} />
        </div>
      </div>
    </section>
  )
}
